import { LazyImage } from '../../base'

function LoadingScreen({ error = false }) {
    return (
        <div className='loadingScreen position-fixed' style={{ width: '100%', height: '100%', top: 0, left: 0, zIndex: '100', background: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', fontFamily: 'cursive' }} >
            {
                error ?
                    <div className='d-flex flex-column justify-content-center gap-3 text-center'>
                        <div>
                            <LazyImage src={`/logo192.png`} alt={'logo192.png'} />
                            <div className='h4 mt-3 text-center'><span className='focolor'>Ahilya</span> <span className='scolor'>Handlooms</span></div>
                        </div>
                        <h2 className='h7'>Something went wrong.</h2>
                        <button className='primaryButton' onClick={() => window.location.reload()}>Reload</button>
                    </div> :
                    <>
                        <div>
                            <LazyImage src={`/logo192.png`} alt={'logo192.png'} />
                            <div className='h4 mt-3 text-center'><span className='focolor'>Ahilya</span> <span className='scolor'>Handlooms</span></div>
                        </div>
                        <div className='position-fixed text-center' style={{ bottom: '30px' }}>
                            <div>From Maheshwar</div>
                        </div>
                    </>
            }
        </div>
    )
}

export default LoadingScreen